// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-sm":"(min-width: 768px)","mediaBreakpointSm":"(min-width: 768px)","mobile-button":"_39QigUTk flex justify-center","mobileButton":"_39QigUTk flex justify-center"};